import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import {
  Box,
  Chip,
  Divider,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@material-ui/core";

import MainCard from "../../ui-component/cards/MainCard";
import SubCard from "../../ui-component/cards/SubCard";
import { gridSpacing } from "../../store/constant";
import CalendarTodayTwoToneIcon from "@material-ui/icons/CalendarTodayTwoTone";
import DescriptionTwoToneIcon from "@material-ui/icons/DescriptionTwoTone";
import PhoneAndroidTwoToneIcon from "@material-ui/icons/PhoneAndroidTwoTone";
import { getDecryptDataFromLocal } from "../../utils/encrypt";
import { Button, IconButton, Input, Stack, TextField, LinearProgress, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import BulkInvoice from "./BulkInvoice";
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import OrderStatus from "./OrderStatus";
import PerformaInvoice from "./PerformaInvoice";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EventIcon from "@mui/icons-material/Event";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { MoneyOff } from "@material-ui/icons";
import RefundModal from "./Bulk-Component/RefundModal";
import EditAddressInOrderModal from "./EditAddressInOrderModal";
import CancelOrderReasonFields from "./CancelOrderReasonFields";
import moment from "moment";
import OtpModal from "../../Components/OtpModal";

const useStyles = makeStyles((theme) => ({
  accountTab: {
    "& a": {
      minHeight: "auto",
      minWidth: "10px",
      padding: "12px 8px",
      marginRight: "18px",
      color: theme.palette.grey[600],
    },
    "& a.Mui-selected": {
      color: theme.palette.primary.main,
    },
    "& a > span": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    "& a > span > svg": {
      marginBottom: "0px !important",
      marginRight: "10px",
    },
    "& a > span > span + svg": {
      margin: "0px 0px 0px auto !important",
      width: "14px",
      height: "14px",
    },
  },

  customerHeadDetails: {
    "& > svg": {
      width: "15px",
      height: "15px",
      verticalAlign: "text-top",
      marginRight: "5px",
      marginTop: "2px",
    },
  },

  tableResponsive: {
    overflowX: "auto",
  },
  totalBillAmount: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.primary.light,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Order History Component
function OrderHistory({ order }) {
  if (!order?.shiprocketLogs || !Array.isArray(order.shiprocketLogs) || order.shiprocketLogs.length === 0) {
    return null;
  }

  // Extract history from shiprocketLogs
  const getHistory = () => {
    const history = [];

    // Find the first log object that has tracking_data
    const logWithTrackingData = order.shiprocketLogs.find((log) => log.tracking_data);

    if (logWithTrackingData && logWithTrackingData.tracking_data) {
      // Priority: Use tracking_data if present
      const trackingData = logWithTrackingData.tracking_data;

      // Check for tracking_data.status_history
      if (trackingData.status_history && Array.isArray(trackingData.status_history)) {
        trackingData.status_history.forEach((item) => {
          history.push({
            date: item.date || item.timestamp || item.added_at,
            action: item.activity || item.status,
            location: item.location || "",
            reason: item.reason || item.remarks || "",
          });
        });
      }

      // Check for tracking_data.shipment_track_activities (if status_history not found)
      if (history.length === 0 && trackingData.shipment_track_activities && Array.isArray(trackingData.shipment_track_activities)) {
        trackingData.shipment_track_activities.forEach((item) => {
          history.push({
            date: item.date || item.timestamp || item.added_at,
            action: item.activity || item.status,
            location: item.location || "",
            reason: item.reason || item.remarks || "",
          });
        });
      }
    } else {
      // Fallback: Use root level data from first log object only
      const firstLog = order.shiprocketLogs[0];

      // Check for status_history
      if (firstLog.status_history && Array.isArray(firstLog.status_history)) {
        firstLog.status_history.forEach((item) => {
          history.push({
            date: item.date || item.timestamp || item.added_at,
            action: item.activity || item.status,
            location: item.location || "",
            reason: item.reason || item.remarks || "",
          });
        });
      }

      // Check for shipment_track_activities (if status_history not found)
      if (history.length === 0 && firstLog.shipment_track_activities && Array.isArray(firstLog.shipment_track_activities)) {
        firstLog.shipment_track_activities.forEach((item) => {
          history.push({
            date: item.date || item.timestamp || item.added_at,
            action: item.activity || item.status,
            location: item.location || "",
            reason: item.reason || item.remarks || "",
          });
        });
      }
    }

    // Sort by date (newest first)
    return history.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
  };

  const history = getHistory();

  if (history.length === 0) {
    return null;
  }

  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          Order History
        </Typography>
        <Box sx={{ overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Date & Time</strong></TableCell>
                <TableCell><strong>Action/Status</strong></TableCell>
                <TableCell><strong>Location</strong></TableCell>
                <TableCell><strong>Reason</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {item.date ? moment(item.date).format("DD-MMM-YYYY hh:mm A") : "-"}
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {item.action || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {item.location || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {item.reason || "-"}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  );
}

// Status Bar Component
function OrderStatusBar({ order }) {
  const [cancellationAgent, setCancellationAgent] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);

  // Fetch cancellation agent details when order is cancelled
  useEffect(() => {
    const fetchCancellationAgent = async () => {
      if (order?.status === 2 && order?.cancelledBy?.cancelledBy) {
        setLoadingAgent(true);
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_PATH_BULK}/admin/getAgentsByAgentId`,
            {
              agentIds: [order.cancelledBy.cancelledBy],
              forCancel: true,
            }
          );
          if (response.data.success && response.data.data && response.data.data.length > 0) {
            setCancellationAgent(response.data.data[0]);
          }
        } catch (error) {
          console.error("Error fetching cancellation agent:", error);
        } finally {
          setLoadingAgent(false);
        }
      }
    };

    fetchCancellationAgent();
  }, [order?.status, order?.cancelledBy?.cancelledBy]);

  const getStatusInfo = () => {
    const status = order?.status;
    const awbNumber = order?.awbNumber;
    const cancelledBy = order?.cancelledBy;

    if (status === 1 && !awbNumber) {
      return {
        label: "Placed",
        color: "#9e9e9e",
        currentStage: 1,
      };
    } else if (status === 1 && awbNumber) {
      return {
        label: "In-Transit",
        color: "#1976d2",
        currentStage: 2,
      };
    } else if (status === 2) {
      return {
        label: "Cancelled",
        color: "#d32f2f",
        currentStage: 2,
        reason: `Remarks:- ${cancelledBy?.remarks || "Empty"}, Reason:- ${cancelledBy?.reasonText || ""}`,
      };
    } else if (status === 3) {
      return {
        label: "Delivered",
        color: "#2e7d32",
        currentStage: 3,
      };
    } else if (status === 4) {
      return {
        label: "RTO",
        color: "#ed6c02",
        currentStage: 4,
      };
    } else if (status === 8) {
      return {
        label: "Splitted",
        color: "#9c27b0",
        currentStage: 2,
      };
    }
    return {
      label: "Unknown",
      color: "#9e9e9e",
      currentStage: 0,
    };
  };

  const statusInfo = getStatusInfo();
  const isSplitted = order?.status === 8;
  const isCancelled = order?.status === 2;

  // Define stages based on order status
  let stages = [];
  let totalStages = 0;

  if (isSplitted) {
    // For splitted orders: Placed -> Splitted
    stages = [
      { label: "Placed", stage: 1, icon: "check" },
      { label: "Splitted", stage: 2, icon: "check", isSplitted: true },
    ];
    totalStages = 2;
    statusInfo.currentStage = 2;
  } else if (isCancelled) {
    // For cancelled orders: Placed -> Cancelled
    stages = [
      { label: "Placed", stage: 1, icon: "check" },
      { label: "Cancelled", stage: 2, icon: "cross" },
    ];
    totalStages = 2;
    statusInfo.currentStage = 2;
  } else if (order?.status === 4) {
    // For RTO orders
    stages = [
      { label: "Placed", stage: 1, icon: "check" },
      { label: "In-Transit", stage: 2, icon: "check" },
      { label: "Delivered", stage: 3, icon: "check" },
      { label: "RTO", stage: 4, icon: "check" },
    ];
    totalStages = 4;
  } else {
    // Normal flow: Placed -> In-Transit -> Delivered
    stages = [
      { label: "Placed", stage: 1, icon: "check" },
      { label: "In-Transit", stage: 2, icon: "check" },
      { label: "Delivered", stage: 3, icon: "check" },
    ];
    totalStages = 3;
  }

  // Calculate progress percentage - fill from start to current stage's position
  // Stages are evenly distributed: stage 1 at start, last stage at end
  let progressPercentage = 0;
  if (totalStages > 0 && statusInfo.currentStage > 0) {
    if (totalStages === 1) {
      progressPercentage = 100;
    } else if (statusInfo.currentStage === 1) {
      // For "Placed", fill a small portion at the start
      progressPercentage = 15;
    } else {
      // Calculate position: (currentStage - 1) / (totalStages - 1) * 100
      // This gives us the exact position of the current stage circle
      progressPercentage = ((statusInfo.currentStage - 1) / (totalStages - 1)) * 100;
      // Ensure it reaches 100% when at the last stage
      if (statusInfo.currentStage === totalStages) {
        progressPercentage = 100;
      }
    }
  }

  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
            CRM Order Status: {statusInfo.label}
          </Typography>
          {order?.awbNumber && (
            <Typography variant="body1" sx={{ mb: 1, color: "#1976d2", fontWeight: 500 }}>
              AWB Number: {order.awbNumber}
            </Typography>
          )}
          {order?.status === 2 && (
            <>
              {statusInfo.reason && (
                <Typography variant="body2" sx={{ color: "#d32f2f", mb: 1 }}>
                  {statusInfo.reason}
                </Typography>
              )}
              {loadingAgent ? (
                <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                  Loading...
                </Typography>
              ) : cancellationAgent ? (
                <Typography variant="body2" sx={{ color: "#d32f2f", mb: 1 }}>
                  Cancelled By: {cancellationAgent.name}
                </Typography>
              ) : null}
              {order?.cancelledBy?.cancelledAt && (
                <Typography variant="body2" sx={{ color: "#d32f2f", mb: 1 }}>
                  Cancelled On: {moment(order.cancelledBy.cancelledAt).format("DD-MMM-YYYY hh:mm A")}
                </Typography>
              )}
            </>
          )}
        </Box>

        {/* Progress Bar */}
        <Box sx={{ position: "relative", mb: 3, px: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            {/* Progress Line - Background (grey) */}
            <Box
              sx={{
                position: "absolute",
                top: "20px",
                left: "20px",
                right: "20px",
                height: "4px",
                backgroundColor: "#e0e0e0",
                zIndex: 0,
                borderRadius: "2px",
              }}
            >
              {/* Progress Line - Filled portion */}
              <Box
                sx={{
                  height: "100%",
                  width: `${progressPercentage}%`,
                  backgroundColor: isCancelled ? "#d32f2f" : statusInfo.color,
                  transition: "width 0.3s ease",
                  borderRadius: "2px",
                }}
              />
            </Box>

            {/* Stage Nodes */}
            {stages.map((stage, index) => {
              const isCompleted = statusInfo.currentStage >= stage.stage;
              const isCurrent = statusInfo.currentStage === stage.stage;

              // Determine circle color
              let circleColor = "#e0e0e0";
              if (isCompleted || isCurrent) {
                if (stage.isSplitted) {
                  circleColor = "#9c27b0"; // Purple for splitted
                } else if (isCancelled && stage.stage === 2) {
                  circleColor = "#d32f2f"; // Red for cancelled
                } else {
                  circleColor = statusInfo.color;
                }
              }

              return (
                <Box
                  key={index}
                  sx={{
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundColor: circleColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: isCurrent ? `3px solid ${circleColor}` : "none",
                      boxShadow: isCurrent ? `0 0 0 3px ${circleColor}33` : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {/* Icon inside circle */}
                    {stage.icon === "check" && (isCompleted || isCurrent) && (
                      <CheckIcon
                        sx={{
                          color: "#fff",
                          fontSize: "20px",
                          fontWeight: "bold"
                        }}
                      />
                    )}
                    {stage.icon === "cross" && (isCompleted || isCurrent) && (
                      <CloseIcon
                        sx={{
                          color: "#fff",
                          fontSize: "20px",
                          fontWeight: "bold"
                        }}
                      />
                    )}
                    {!isCompleted && !isCurrent && (
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "2px",
                          backgroundColor: "#9e9e9e",
                        }}
                      />
                    )}
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      textAlign: "center",
                      mt: 1,
                      color: isCompleted || isCurrent ? circleColor : "#9e9e9e",
                      fontWeight: isCompleted || isCurrent ? 600 : 400,
                      fontSize: "0.75rem",
                    }}
                  >
                    {stage.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

const BulkOrderDetails = () => {
  const classes = useStyles();
  const { OrderId } = useParams();
  const [openRefundModal, setOpenRefundModal] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const [singleOrder, setSingleOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = React.useState(0);
  const role = getDecryptDataFromLocal("setRole");
  const phoneNumber = getDecryptDataFromLocal("phoneNumber");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [totalCartValue, setTotalCartValue] = useState([]);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [seller, setSeller] = useState({});
  const [appointmentDate, setAppointmentDate] = useState(null);

  // QR Payment linking
  const QR_ALLOWED = ['9719836187', '9315481432', '9873804039', '7011576531'];
  const [qrOrg, setQrOrg] = useState(2);
  const [qrPayId, setQrPayId] = useState('');
  const [qrPayment, setQrPayment] = useState(null);
  const [qrFetchLoading, setQrFetchLoading] = useState(false);
  const [qrLinkLoading, setQrLinkLoading] = useState(false);
  const [qrMsg, setQrMsg] = useState('');
  const [qrMappingAmount, setQrMappingAmount] = useState('');
  const [oldNumericOrderId, setOldNumericOrderId] = useState('');
  const [movePreviewLoading, setMovePreviewLoading] = useState(false);
  const [movePreview, setMovePreview] = useState(null);
  const [movePaymentLoading, setMovePaymentLoading] = useState(false);
  const [movePaymentMsg, setMovePaymentMsg] = useState('');
  const [loadingOfPlaceOrder, setLoadingOfPlaceOrder] = useState(false);

  const [poNumber, setPoNumber] = useState("");
  const [boxCount, setBoxCount] = useState("");

  const [replacementType, setReplacementType] = useState(""); 
  const [replacementDeliveredOrderId, setReplacementDeliveredOrderId] = useState("");
  const [replacementInvoiceNumber, setReplacementInvoiceNumber] = useState("");
  const [replacementReason, setReplacementReason] = useState("");
  const [replacementLoading, setReplacementLoading] = useState(false);

  const [newAwbNumber, setNewAwbNumber] = useState("");
  const [loadingUpdateAwb, setLoadingUpdateAwb] = useState(false);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelDialogMode, setCancelDialogMode] = useState("request"); // "force" | "request"
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRemarks, setCancelRemarks] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);

  const ADDRESS_EDIT_ALLOWED = ["9719836187", "8130902064"];

  // Sheet Order verification-call recording (2026-09-16) — who may actually
  // PLAY it back, mirrors manijment-api routes/role1.js's
  // VERIFICATION_RECORDING_LISTEN_USERS (which also strips recordingUrl out of
  // the API response for anyone else — this FE check is a second, defense-in-
  // depth layer, same dual-check pattern as every other allowlist in this app).
  const VERIFICATION_RECORDING_LISTEN_USERS = ["9811068834", "7011576531"]; // Harshit, Bhawna
  const canHearVerificationRecording = Number(role) === 1 || Number(role) === 2 || VERIFICATION_RECORDING_LISTEN_USERS.includes(phoneNumber);
  const [openEditAddress, setOpenEditAddress] = useState(null); // null | "shipping" | "billing"

  const REOPEN_ALLOWED = ["9315481432"];
  const [reopenLoading, setReopenLoading] = useState(false);

  // Force Cancel — instant status:2, unchanged legacy behavior for these 2 ops numbers.
  const FORCE_CANCEL_ALLOWED = ["9315481432", "9536255229"];
  const [requestCancelLoading, setRequestCancelLoading] = useState(false);

  const handleReopenOrder = async () => {
    if (!window.confirm("Are you sure you want to reopen this cancelled order?")) return;
    setReopenLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PATH_BULK}/role4/reopenCancelledBulkOrder`,
        { orderId: singleOrder._id }
      );
      if (res.data.success === false) {
        alert(res.data.message || "Something went wrong");
      } else {
        alert(res.data.message || "Order reopened successfully");
        dataLoad(false);
      }
    } catch (err) {
      alert(err?.response?.data?.message || "Something went wrong");
    }
    setReopenLoading(false);
  };

  const handleUpdateAwb = async () => {
    if (!newAwbNumber) {
      alert("Please enter AWB Number");
      return;
    }
    setLoadingUpdateAwb(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATH_BULK}/role4/updateAwbForSplittedBulkOrder`,
        {
          awbNumber: newAwbNumber,
          orderId: singleOrder._id,
        }
      );
      if (response.data.success) {
        alert("AWB Number updated successfully");
        window.location.reload();
      } else {
        alert(response.data.message || "Failed to update AWB Number");
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Error updating AWB Number");
    } finally {
      setLoadingUpdateAwb(false);
    }
  };

  const updateZohoInvoiceDetails = () => {
    if (poNumber === (singleOrder?.poNumber || "") && boxCount === (singleOrder?.boxCount || "")) {
      alert("No changes detected");
      return;
    }
    setLoadingOfPlaceOrder(true);
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/role1/updateZohoInvoice", {
        orderId: OrderId,
        poNumber: poNumber,
        boxCount: boxCount,
      })
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message);
          dataLoad(false);
        } else {
          alert(res.data.message);
        }
        setLoadingOfPlaceOrder(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoadingOfPlaceOrder(false);
      });
  };

  const handleForceCancel = async () => {
    if (!cancelReason.trim()) {
      alert("Please enter a reason");
      return;
    }
    setCancelLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PATH_BULK}/role4/forceCancelBulkOrder`,
        { orderId: OrderId, reason: cancelReason, remarks: cancelRemarks }
      );
      if (res.data.success) {
        alert(res.data.message || "Order cancelled successfully");
        setShowCancelModal(false);
        dataLoad(false);
      } else {
        alert(res.data.message || "Something went wrong");
      }
    } catch (err) {
      alert(err?.response?.data?.message || "Something went wrong");
    }
    setCancelLoading(false);
  };

  const handleRequestCancel = async () => {
    if (!cancelReason.trim()) {
      alert("Please enter a reason");
      return;
    }
    setRequestCancelLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PATH_BULK}/role4/requestCancelBulkOrder`,
        { orderId: OrderId, reason: cancelReason, remarks: cancelRemarks }
      );
      if (res.data.success) {
        alert(res.data.message || "Cancellation requested — pending review");
        setShowCancelModal(false);
        dataLoad(false);
      } else {
        alert(res.data.message || "Something went wrong");
      }
    } catch (err) {
      alert(err?.response?.data?.message || "Something went wrong");
    }
    setRequestCancelLoading(false);
  };

  const makeReplacementOrder = () => {
    if (!replacementReason) {
      alert("Replacement reason is required");
      return;
    }
    if (replacementType === "online" && !replacementDeliveredOrderId) {
      alert("Delivered Order ID is required for online order");
      return;
    }
    if (replacementType === "invoice" && !replacementInvoiceNumber) {
      alert("Invoice Number is required for invoice");
      return;
    }
    if (!replacementType) {
      alert("Please select a replacement source");
      return;
    }

    setReplacementLoading(true);
    axios
      .post(`${process.env.REACT_APP_PATH_BULK}/testing/markOrderToAreplacementOrder`, {
        orderId: singleOrder?.numericOrderId,
        deliveredOrderId: replacementType === "online" ? replacementDeliveredOrderId : undefined,
        invoiceNumber: replacementType === "invoice" ? replacementInvoiceNumber : undefined,
        replacementReason: replacementReason,
      })
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message);
          dataLoad(true);
        } else {
          alert(res.data.message || "Failed to mark replacement order");
        }
      })
      .catch((err) => {
        console.error(err);
        alert(err.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setReplacementLoading(false);
      });
  };

  const getAmountOfPartialPayment = () => {
    axios
      .post(
        process.env.REACT_APP_PATH_BULK +
        "/sales/getNeededPrepaidAmountForBulkOrder",
        {
          orderId: OrderId,
        }
      )
      .then((res) => {
        if (res.data.success) {
          dataLoad();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const dataLoad = (isLoading = true) => {
    if (isLoading) setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_PATH_BULK}/role1/allCapturedOrders/${OrderId}`
      )
      .then((res) => {
        if (res?.data?.success) {
          let orderrr = res?.data?.data[0] || [];
          setSingleOrder(orderrr);
          setNewAwbNumber(orderrr?.awbNumber || "");
          if (
            orderrr.paymentMethod == 1 &&
            orderrr.status == 1 &&
            !orderrr?.collectedAmountDueToHighReachedAtDesti
          ) {
            getAmountOfPartialPayment();
          }
          setTotalPayableAmount(
            orderrr?.collectedAmountDueToHighReachedAtDesti || 0
          );
          setAppointmentDate(orderrr?.appointmentDate || null)
          setPoNumber(orderrr?.poNumber || "");
          setBoxCount(orderrr?.boxCount || "");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const createRazorPayId = () => {
    setLoadingOfPlaceOrder(true);
    axios
      .post(
        `${process.env.REACT_APP_PATH_BULK}/products/createRazorpayOrderForCrm`,
        {
          orderId: OrderId,
          sellerId: singleOrder?.sellerId,
        }
      )
      .then((res) => {
        if (res.data.success) {
          handlePaymemt(res.data.data.razorPayOrderId);
        } else {
          alert(res.data.message);
          setLoadingOfPlaceOrder(false);
        }
      })
      .catch((e) => {
        console.log("Error!", e);
        setLoadingOfPlaceOrder(false);
      });
  };

  const captureOrder = (razorPayId, razorpayOrderId) => {
    console.log("razor[a", razorPayId);
    setLoadingOfPlaceOrder(true);
    axios
      .post(
        process.env.REACT_APP_PATH_BULK +
        "/sales/captureRazorpayPaymentForBulkOrder",
        {
          orderId: OrderId,
          razorPayOrderId: razorpayOrderId,
          razorPayId: razorPayId,
        }
      )
      .then((res) => {
        if (res.data.success) {
          console.log("res of capture order", res.data);
          alert(res.data.message);
          setLoadingOfPlaceOrder(false);
          window.location.reload();
        } else {
          alert(res.data.message);
          setLoadingOfPlaceOrder(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        alert(error?.response?.data?.message || "something went wrong");
        setLoadingOfPlaceOrder(false);
      });
  };

  const handlePaymemt = (razorPayid) => {
    var options = {
      key: "rzp_live_E2nnls6jq3jBMt", // Enter the Key ID generated from the Dashboard
      // key: "rzp_test_Ax7N4MA8EfQkcO", // Enter the Key ID generated from the Dashboard
      amount: Math.round(totalPayableAmount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Buyume",
      description: `To Seller: ${singleOrder.name}`,
      image:
        "https://res.cloudinary.com/dyqcevdpm/image/upload/v1623494311/Buyum_Logo_mfb5xz.png",
      order_id: razorPayid, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      callback_url: "",
      handler: function (response) {
        captureOrder(response.razorpay_payment_id, razorPayid);
      },
      prefill: {
        name: `{singleOrder.name}`,
        email: "test@buyume.com",
      },
      notes: {
        orderId: OrderId,
        orderType: "",
      },
      theme: {
        color: "#002A56",
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      alert(response.error.description);
    });
    rzp1.open();
  };

  const fetchQrPayment = async () => {
    if (!qrPayId.trim()) { alert("Enter a Payment ID"); return; }
    setQrFetchLoading(true);
    setQrPayment(null);
    setQrMsg('');
    setQrMappingAmount('');
    try {
      const res = await axios.post(process.env.REACT_APP_PATH_BULK + "/products/fetchQrPaymentDetails", {
        payId: qrPayId.trim(),
        organization: qrOrg,
      });
      if (res.data.success) {
        setQrPayment(res.data.data);
      } else {
        setQrMsg(res.data.message || "Failed to fetch payment");
      }
    } catch (e) {
      setQrMsg("Error fetching payment");
    }
    setQrFetchLoading(false);
  };

  const linkQrPayment = async () => {
    if (!qrPayment) return;
    const availableAmount = qrPayment.availableAmount;
    const orderTotal = singleOrder?.totalPayableAmount || 0;
    const orderRemaining = singleOrder?.remainingAmountForCod != null ? singleOrder.remainingAmountForCod : orderTotal;
    const enteredAmount = qrMappingAmount ? Number(qrMappingAmount) : null;

    if (enteredAmount !== null) {
      if (isNaN(enteredAmount) || enteredAmount <= 0) { setQrMsg("Enter a valid amount"); return; }
      if (enteredAmount > availableAmount) { setQrMsg(`₹${enteredAmount} exceeds available balance ₹${availableAmount}`); return; }
      if (enteredAmount > orderRemaining) { setQrMsg(`₹${enteredAmount} exceeds order remaining ₹${orderRemaining}`); return; }
    }

    const mapAmt = enteredAmount !== null ? enteredAmount : Math.min(availableAmount, orderRemaining);
    if (!window.confirm(`Map ₹${mapAmt} from this QR payment (${qrPayment.id}) to Order #${singleOrder?.numericOrderId}?\n\nThis cannot be undone. Continue?`)) return;

    setQrLinkLoading(true);
    setQrMsg('');
    try {
      const body = { orderId: OrderId, payId: qrPayment.id, organization: qrOrg };
      if (enteredAmount !== null) body.mappingAmount = enteredAmount;
      const res = await axios.post(process.env.REACT_APP_PATH_BULK + "/products/linkQrPaymentToOrder", body);
      if (res.data.success) {
        const d = res.data.data;
        const bal = d.paymentBalance;
        setQrMsg(`✓ Mapped ₹${d.mappedAmount} | Method: ${d.paymentMethod == 2 ? 'Full Prepaid' : 'Partial'}${d.remainingOnOrder ? ` | COD remaining on order: ₹${d.remainingOnOrder}` : ''} | Payment balance: ₹${bal?.availableAmount} left`);
        setQrPayment(null);
        setQrPayId('');
        setQrMappingAmount('');
        window.location.reload();
      } else {
        setQrMsg(res.data.message || "Failed to link");
      }
    } catch (e) {
      setQrMsg("Error linking payment");
    }
    setQrLinkLoading(false);
  };

  const previewMoveFromOldOrder = async () => {
    if (!oldNumericOrderId.trim()) { setMovePaymentMsg("Enter the old order's numeric order id"); return; }
    setMovePreviewLoading(true);
    setMovePreview(null);
    setMovePaymentMsg('');
    try {
      const res = await axios.post(process.env.REACT_APP_PATH_BULK + "/products/previewOldOrderPaymentMove", {
        oldNumericOrderId: Number(oldNumericOrderId.trim()),
        orderId: OrderId,
      });
      if (res.data.success) {
        setMovePreview(res.data.data);
      } else {
        setMovePaymentMsg(res.data.message || "Failed to fetch old order payment details");
      }
    } catch (e) {
      setMovePaymentMsg("Error fetching old order payment details");
    }
    setMovePreviewLoading(false);
  };

  const confirmMoveFromOldOrder = async () => {
    if (!movePreview) return;
    const oldLabel = movePreview.oldOrder.status === 4 ? 'RTO' : 'Cancelled';
    if (!window.confirm(
      `Map ₹${movePreview.oldOrder.paidAmount} from ${oldLabel} Order #${movePreview.oldOrder.numericOrderId} to this order (#${movePreview.newOrder.numericOrderId})?\n\n` +
      `After mapping:\nPrepaid Collected: ₹${movePreview.afterMove.prepaidCollectedAmount}\n` +
      `Remaining for COD: ₹${movePreview.afterMove.remainingAmountForCod}\n` +
      `Payment Method: ${movePreview.afterMove.paymentMethod === 2 ? 'Full Prepaid' : 'Partial'}\n\n` +
      `This cannot be undone. Continue?`
    )) return;
    setMovePaymentLoading(true);
    setMovePaymentMsg('');
    try {
      const res = await axios.post(process.env.REACT_APP_PATH_BULK + "/products/mapOldOrderPaymentToNewOrder", {
        oldNumericOrderId: Number(oldNumericOrderId.trim()),
        orderId: OrderId,
      });
      if (res.data.success) {
        const d = res.data.data;
        setMovePaymentMsg(`✓ Moved ₹${d.movedAmount} | Method: ${d.paymentMethod == 2 ? 'Full Prepaid' : 'Partial'}${d.remainingOnOrder ? ` | COD remaining: ₹${d.remainingOnOrder}` : ''}`);
        setOldNumericOrderId('');
        setMovePreview(null);
        window.location.reload();
      } else {
        setMovePaymentMsg(res.data.message || "Failed to move payment");
      }
    } catch (e) {
      setMovePaymentMsg("Error moving payment");
    }
    setMovePaymentLoading(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const bookAppointment = () => {
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/addAppointmentDate", {
        orderId: OrderId,
        appointmentDate: appointmentDate,
      })
      .then((res) => {
        if (res.data.success) {
          alert(res.data?.message || "Successfully booked");
          dataLoad()
        } else {
          alert(res.data?.message || "Something went wrong");
        }
      })
      .catch((error) => {
        console.log("error of book appointment", error);
        alert("Server error");
      });
  };

  // Map Payment Logic
  const [mapPaymentData, setMapPaymentData] = useState({
    amount: "",
    paymentId: "",
    paymentDateAndTime: null,
    screenshot: null,
  });
  const [screenshotInputKey, setScreenshotInputKey] = useState(0);
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [openPaymentPopup, setOpenPaymentPopup] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);

  // Only this user can map payments — backend Helper.mapPayment enforces the same allowlist.
  const canMapPayment = String(phoneNumber || "") === "8130902064";

  // Multiple payments can be mapped — a partially paid order (method 6) keeps taking
  // payments until fully covered. Mapped IDs live in razorPayOrderId as "id1 + id2".
  const isPartialPaidOrder = singleOrder?.paymentMethod === 6;
  const alreadyCollected = isPartialPaidOrder ? Number(singleOrder?.prepaidCollectedAmount || 0) : 0;
  const remainingPayable = Math.max(0, Math.round((Number(singleOrder?.totalPayableAmount || 0) - alreadyCollected) * 100) / 100);
  const mappedPaymentIds = isPartialPaidOrder && singleOrder?.razorPayOrderId
    ? String(singleOrder.razorPayOrderId).split("+").map((id) => id.trim()).filter(Boolean)
    : [];

  const executeMapPayment = () => {
    // Multipart so the mandatory payment screenshot goes up with the mapping;
    // backend uploads it to S3 and stores the link on the order.
    const payload = new FormData();
    payload.append("orderId", OrderId);
    payload.append("amount", Number(mapPaymentData.amount));
    payload.append("paymentId", mapPaymentData.paymentId.trim());
    payload.append("screenshot", mapPaymentData.screenshot);

    if (mapPaymentData.paymentDateAndTime) {
      payload.append("paymentDateAndTime", dayjs(mapPaymentData.paymentDateAndTime).format("YYYY-MM-DD HH:mm:ss"));
    }

    axios.post(`${process.env.REACT_APP_PATH_BULK}/role1/mapPayment`, payload)
      .then((res) => {
        setPaymentResponse(res.data);
        setOpenPaymentPopup(true);

        if (res.data.success) {
          setMapPaymentData({ amount: "", paymentId: "", paymentDateAndTime: null, screenshot: null });
          setScreenshotInputKey((k) => k + 1);
          dataLoad(false);
        }

        setTimeout(() => {
          setOpenPaymentPopup(false);
          setPaymentResponse(null);
        }, 5000);
      })
      .catch((err) => {
        console.error(err);
        if (err.response && err.response.data) {
          setPaymentResponse(err.response.data);
          setOpenPaymentPopup(true);
          setTimeout(() => {
            setOpenPaymentPopup(false);
            setPaymentResponse(null);
          }, 5000);
        } else {
          alert("Something went wrong");
        }
      });
  };

  const sendOTP = () => {
    axios
      .post(
        process.env.REACT_APP_PATH + "/api/sendOtp",
        {
          phoneNumber: '8130902064',
        }
      )
      .then((response) => {
        if (response.data.success) {
          setOtpModalOpen(true);
        } else {
          alert("Failed to send OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Error sending OTP");
      });
  };

  const handleOtpVerify = (otp) => {
    axios
      .post(
        process.env.REACT_APP_PATH + "/api/validateOtp",
        {
          phoneNumber: "8130902064",
          otp: otp,
        }
      )
      .then((response) => {
        if (response.data.success) {
          setOtpModalOpen(false);
          executeMapPayment();
        } else {
          alert(response.data.message || "Invalid OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Error verifying OTP");
      });
  };

  const handleMapPaymentSubmit = () => {
    if (!canMapPayment) {
      alert("You are not allowed to map payments");
      return;
    }

    if (!mapPaymentData.amount || !mapPaymentData.paymentId) {
      alert("Amount and Payment ID are required");
      return;
    }

    const enteredAmount = Number(mapPaymentData.amount);
    if (!(enteredAmount > 0)) {
      alert("Amount must be greater than 0");
      return;
    }
    if (enteredAmount > remainingPayable) {
      alert(`Amount cannot be more than the remaining payable amount (₹${remainingPayable})`);
      return;
    }
    if (mappedPaymentIds.includes(mapPaymentData.paymentId.trim())) {
      alert("This payment ID is already mapped to this order");
      return;
    }
    if (!mapPaymentData.screenshot) {
      alert("Payment screenshot is required");
      return;
    }
    if (!mapPaymentData.screenshot.type?.startsWith("image/")) {
      alert("Payment screenshot must be an image");
      return;
    }
    if (mapPaymentData.screenshot.size > 10 * 1024 * 1024) {
      alert("Payment screenshot must be under 10MB");
      return;
    }

    if (Number(mapPaymentData.amount) >= 10000) {
      sendOTP();
      return;
    }

    if (!window.confirm("Are you sure you want to submit this payment mapping?")) {
      return;
    }

    executeMapPayment();
  };

  useEffect(() => {
    dataLoad();
  }, []);

  if (loading) {
    return <div>Loading</div>;
  }

  return (
    <MainCard>
      <Tabs
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        variant="scrollable"
        className={classes.accountTab}
        aria-label="simple tabs example"
        sx={{ mb: 3 }}
      >
        <Tab
          icon={<DescriptionTwoToneIcon />}
          component={Link}
          to="#"
          label="Details"
          value={0}
          {...a11yProps(0)}
        />
        <Tab
          icon={<DescriptionTwoToneIcon />}
          component={Link}
          to="#"
          label="Invoice"
          value={1}
          {...a11yProps(1)}
        />
        <Tab
          icon={<DescriptionTwoToneIcon />}
          component={Link}
          to="#"
          label="Proforma invoice "
          value={2}
          {...a11yProps(2)}
        />
        <Tab
          icon={<LocalShippingTwoToneIcon />}
          component={Link}
          to="#"
          label="Status"
          value={3}
          {...a11yProps(3)}
          disabled={
            singleOrder?.awbNumber == "FLORIDA_BEAUTY" ||
            singleOrder?.awbNumber == "EMERGENT"
          }
        />
        <Tab
          icon={<DescriptionTwoToneIcon />}
          component={Link}
          to="#"
          label="CRM Status"
          value={4}
          {...a11yProps(4)}
        />
        {(singleOrder?.isReplacementOrder || (singleOrder?.status === 1 && !singleOrder?.awbNumber)) && (
          <Tab
            icon={<DescriptionTwoToneIcon />}
            component={Link}
            to="#"
            label="Replacement"
            value={7}
            {...a11yProps(7)}
          />
        )}
        {singleOrder?.zohoInvoice?.invoiceUrl && (
          <Tab
            icon={<DescriptionTwoToneIcon />}
            component={Link}
            to="#"
            label="Zoho Invoice"
            value={5}
            {...a11yProps(5)}
          />
        )}
        {canMapPayment && (
          <Tab
            icon={<DescriptionTwoToneIcon />}
            component={Link}
            to="#"
            label="Map Payment"
            value={6}
            {...a11yProps(6)}
          />
        )}
      </Tabs>

      <TabPanel value={value} index={0}>
        <Grid container spacing={gridSpacing}>
          <Grid item xs={12}>
            <SubCard
              title="Order Details"
              secondary={
                <Typography variant="subtitle1">
                  Place On : {new Date(singleOrder?.createdAt).toDateString()}{" "}
                  {new Date(singleOrder?.createdAt).toLocaleTimeString()}
                </Typography>
              }
            >
              <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item>
                      <Typography
                        variant="body2"
                        className={classes.customerHeadDetails}
                      >
                        <CalendarTodayTwoToneIcon /> {singleOrder?.name}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="body2"
                        className={classes.customerHeadDetails}
                      >
                        <PhoneAndroidTwoToneIcon /> {singleOrder?.phoneNumber}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {singleOrder?.sheetOrderVerification?.verifiedByName && (
                  <Grid item xs={12}>
                    <Box
                      style={{
                        display: "flex", alignItems: "center", flexWrap: "wrap", gap: 12,
                        padding: "8px 12px", background: "#e3f2fd", border: "1px solid #bbdefb", borderRadius: 4,
                      }}
                    >
                      <Typography variant="body2" style={{ color: "#0d47a1" }}>
                        <b>Verified by:</b> {singleOrder.sheetOrderVerification.verifiedByName}
                        {singleOrder.sheetOrderVerification.verifiedAt && (
                          <span style={{ marginLeft: 6 }}>
                            on {new Date(singleOrder.sheetOrderVerification.verifiedAt).toLocaleString()}
                          </span>
                        )}
                      </Typography>
                      {singleOrder.sheetOrderVerification.recordingUrl && canHearVerificationRecording && (
                        <audio controls src={singleOrder.sheetOrderVerification.recordingUrl} style={{ height: 32 }} />
                      )}
                      {singleOrder.sheetOrderVerification.recordingUrl && !canHearVerificationRecording && (
                        <Typography variant="caption" style={{ color: "#1565c0" }}>
                          Recording available — admin/SCM only
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} container>
                  <Grid item xs={6}>
                    <Grid container spacing={gridSpacing}>
                      {[
                        { type: "shipping", title: "Shipping address", addr: singleOrder?.address },
                        { type: "billing", title: "Billing address", addr: singleOrder?.billingAddress },
                      ].map(({ type, title, addr }) => (
                        <Grid item sm={10} key={type}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <Typography variant="h4">{title}</Typography>
                              {ADDRESS_EDIT_ALLOWED.includes(phoneNumber) && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => setOpenEditAddress(type)}
                                >
                                  {addr ? "Edit" : "Add"}
                                </Button>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {addr ? (
                              <Grid container spacing={0}>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    First name : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.name}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    Phone : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.phoneNumber}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    Address Line 1 : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.address1}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    Address Line 2 : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.address2}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    Landmark : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.landmark}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    City : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.city}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    State : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.state}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle1">
                                    Postal code : &nbsp;
                                    <Typography component="span" variant="body2">
                                      {addr?.postalCode}
                                    </Typography>
                                  </Typography>
                                </Grid>
                              </Grid>
                              ) : (
                                <Typography variant="body2">Address Not Found</Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid spacing={gridSpacing}>
                      <Grid container position={"relative"}>
                        <Typography variant="h4">
                          {" "}
                          Payment method : &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          {singleOrder?.paymentMethod === 1
                            ? " Cash Payment"
                            : " Online Payment"}
                        </Typography>
                        {totalPayableAmount &&
                          totalPayableAmount > 0 &&
                          singleOrder?.paymentMethod == 1 ?
                          <Button variant='outlined' size='small' sx={{ alignItems: 'end', justifyItems: 'flex-end', position: 'absolute', top: '10px', right: '10px' }} onClick={getAmountOfPartialPayment}>Refresh Payment</Button>
                          : null}
                      </Grid>
                      <Typography variant="subtitle1">
                        Transaction ID : &nbsp;
                        <Typography component="span" variant="body2">
                          {singleOrder?.numericOrderId}
                        </Typography>
                      </Typography>
                      {
                        singleOrder?.paymentMethod == 1 && <Typography variant="subtitle1">
                          Total Payable : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder?.totalPayableAmount}
                          </Typography>
                        </Typography>
                      }
                      {
                        (singleOrder?.paymentMethod == 2 || singleOrder?.paymentMethod == 6) && (
                          <Typography variant="subtitle1">
                            Razorpay Id : &nbsp;
                            <Typography component="span" variant="body2">
                              {singleOrder?.razorPayObj?.id}
                            </Typography>
                          </Typography>
                        )
                      }
                      {totalPayableAmount &&
                        totalPayableAmount > 0 &&
                        singleOrder?.paymentMethod == 1 ? (
                        <Grid
                          item
                          xs={8}
                          container
                          style={{
                            border: "1px dashed #000",
                            padding: "5px 10px",
                            marginTop: 20,
                          }}
                        >
                          <Grid item xs={12} lg={6}>
                            <Typography variant="subtitle1">
                              Partial Payment :
                            </Typography>
                            <Typography>
                              Pay Now {totalPayableAmount}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            justifyContent={"flex-end"}
                            container
                          >
                            <LoadingButton
                              loading={loadingOfPlaceOrder}
                              loadingIndicator="Wait..."
                              variant="contained"
                              onClick={createRazorPayId}
                              style={{ width: 160 }}
                            >
                              Pay
                            </LoadingButton>
                          </Grid>
                        </Grid>
                      ) : null}
                      {["9719836187", "9315481432"].includes(phoneNumber) && (
                        <Grid mt={1}>
                          {singleOrder?.status == 2 && (singleOrder?.paymentMethod == 2 || singleOrder?.paymentMethod == 6) && (
                            <Button
                              variant="contained"
                              size="large"
                              onClick={() => {
                                setOpenRefundModal(true);
                              }}
                              disabled={singleOrder?.partialRefund?.userId}
                            >
                              {singleOrder?.partialRefund?.userId
                                ? "Already Refund"
                                : "Refund"}
                            </Button>
                          )}
                        </Grid>
                      )}
                      
                      {/* Additional Order Details */}
                      {singleOrder?.shippingSuggestion && (
                        <Typography variant="subtitle1" sx={{ mt: 2 }}>
                          Shipping Suggestion : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.shippingSuggestion}
                          </Typography>
                        </Typography>
                      )}
                      {singleOrder?.weight && (
                        <Typography variant="subtitle1">
                          Weight : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.weight}
                          </Typography>
                        </Typography>
                      )}
                      {singleOrder?.totalPayableAmount && singleOrder?.paymentMethod != 1 && (
                        <Typography variant="subtitle1">
                          Total Payable : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.totalPayableAmount}
                          </Typography>
                        </Typography>
                      )}
                      {singleOrder?.prepaidCollectedAmount && (
                        <Typography variant="subtitle1">
                          Prepaid Collected Amount : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.prepaidCollectedAmount}
                          </Typography>
                        </Typography>
                      )}
                      {singleOrder?.remainingAmountForCod && (
                        <Typography variant="subtitle1">
                          Remaining Amount for COD : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.remainingAmountForCod}
                          </Typography>
                        </Typography>
                      )}
                      {singleOrder?.razorPayOrderId && (
                        <Typography variant="subtitle1">
                          Razorpay Order ID : &nbsp;
                          <Typography component="span" variant="body2">
                            {singleOrder.razorPayOrderId}
                          </Typography>
                        </Typography>
                      )}

                      {/* ── QR Payment Linking (restricted) ── */}
                      {QR_ALLOWED.includes(phoneNumber) && singleOrder?.status === 1 && (singleOrder?.paymentMethod === 1 || singleOrder?.paymentMethod === 6)  && (
                        <Grid mt={2} p={2} sx={{ border: '1px dashed #1976d2', borderRadius: 2, background: '#f0f7ff' }}>
                          <Typography variant="subtitle1" fontWeight={600} mb={1}>
                            {singleOrder?.qrPaymentLinked ? 'Add Second QR Payment to Order' : 'Link QR Payment to Order'}
                          </Typography>

                          {/* Org selector */}
                          <FormControl size="small" sx={{ minWidth: 160, mr: 1, mb: 1 }}>
                            <InputLabel>Organization</InputLabel>
                            <Select value={qrOrg} label="Organization" onChange={e => { setQrOrg(e.target.value); setQrPayment(null); setQrMsg(''); }}>
                              <MenuItem value={1}>Emergent</MenuItem>
                              <MenuItem value={2}>Florida Beauty Labs</MenuItem>
                              <MenuItem value={3}>Crescent</MenuItem>
                            </Select>
                          </FormControl>

                          {/* Pay ID input */}
                          <TextField
                            size="small"
                            label="Payment ID (pay_XXXX)"
                            value={qrPayId}
                            onChange={e => { setQrPayId(e.target.value); setQrPayment(null); setQrMsg(''); }}
                            sx={{ mr: 1, mb: 1, minWidth: 220 }}
                          />
                          <LoadingButton
                            loading={qrFetchLoading}
                            variant="outlined"
                            size="small"
                            onClick={fetchQrPayment}
                            sx={{ mb: 1 }}
                          >
                            Fetch
                          </LoadingButton>

                          {/* Payment preview */}
                          {qrPayment && (
                            <Grid mt={1} p={1.5} sx={{ background: '#fff', borderRadius: 1, border: '1px solid #b0c4de' }}>
                              <Typography variant="body2">ID: <b>{qrPayment.id}</b></Typography>
                              <Typography variant="body2">Status: <b style={{ color: qrPayment.status === 'captured' ? 'green' : 'red' }}>{qrPayment.status}</b> &nbsp;|&nbsp; Method: {qrPayment.method}</Typography>

                              {/* Payment balance breakdown */}
                              <Grid mt={0.5} p={1} sx={{ background: '#f5f5f5', borderRadius: 1 }}>
                                <Typography variant="body2">Total Payment: <b>₹{qrPayment.amount}</b></Typography>
                                <Typography variant="body2" color={qrPayment.usedAmount > 0 ? 'warning.main' : 'text.secondary'}>
                                  Already used: <b>₹{qrPayment.usedAmount}</b>
                                  {qrPayment.mappedOrders?.length > 0 && (
                                    <span style={{ fontSize: 11, marginLeft: 6 }}>
                                      ({qrPayment.mappedOrders.map(o => `Order #${o.numericOrderId || o.orderId.slice(-5)}: ₹${o.amount}`).join(', ')})
                                    </span>
                                  )}
                                </Typography>
                                <Typography variant="body2" color="success.main">Available: <b>₹{qrPayment.availableAmount}</b></Typography>
                              </Grid>

                              {/* Optional mapping amount */}
                              {(() => {
                                const orderRemaining = singleOrder?.remainingAmountForCod != null ? singleOrder.remainingAmountForCod : (singleOrder?.totalPayableAmount || 0);
                                const maxAllowed = Math.min(qrPayment.availableAmount, orderRemaining);
                                return (
                                  <Grid mt={1} display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                    <TextField
                                      size="small"
                                      label={`Map amount (max ₹${maxAllowed})`}
                                      type="number"
                                      value={qrMappingAmount}
                                      onChange={e => {
                                        const val = e.target.value;
                                        if (val === '') { setQrMappingAmount(''); return; }
                                        const num = Number(val);
                                        if (num > maxAllowed) setQrMappingAmount(String(maxAllowed));
                                        else setQrMappingAmount(val);
                                      }}
                                      sx={{ width: 220 }}
                                      helperText={singleOrder?.qrPaymentLinked ? `₹${singleOrder.prepaidCollectedAmount || 0} already mapped — ${orderRemaining} remaining` : "Leave blank to map full available or order remaining (whichever is less)"}
                                      inputProps={{ min: 1, max: maxAllowed, step: 0.01 }}
                                    />
                                  </Grid>
                                );
                              })()}

                              <Typography variant="body2" mt={1}>
                                Order Total: ₹{singleOrder?.totalPayableAmount} &nbsp;|&nbsp;
                                {(() => {
                                  const orderRemaining = singleOrder?.remainingAmountForCod != null ? singleOrder.remainingAmountForCod : (singleOrder?.totalPayableAmount || 0);
                                  const alreadyMapped = (singleOrder?.totalPayableAmount || 0) - orderRemaining;
                                  const mapAmt = qrMappingAmount ? Number(qrMappingAmount) : Math.min(qrPayment.availableAmount, orderRemaining);
                                  const totalMapped = Math.round((alreadyMapped + mapAmt) * 100) / 100;
                                  const orderTotal = singleOrder?.totalPayableAmount || 0;
                                  return Math.abs(totalMapped - orderTotal) < 1
                                    ? <span style={{ color: 'green' }}>✓ Full Prepaid after this (Method 2)</span>
                                    : <span style={{ color: '#e65100' }}>₹{totalMapped} total prepaid, ₹{Math.round((orderTotal - totalMapped) * 100) / 100} still COD (Method 6)</span>;
                                })()}
                              </Typography>

                              <LoadingButton
                                loading={qrLinkLoading}
                                variant="contained"
                                size="small"
                                color="success"
                                onClick={linkQrPayment}
                                sx={{ mt: 1 }}
                                disabled={qrPayment.status !== 'captured' || qrPayment.availableAmount <= 0}
                              >
                                Confirm & Map Payment
                              </LoadingButton>
                              {qrPayment.availableAmount <= 0 && (
                                <Typography variant="body2" color="error" mt={0.5}>No balance left on this payment</Typography>
                              )}
                            </Grid>
                          )}

                          {qrMsg && (
                            <Typography variant="body2" mt={1} color={qrMsg.startsWith('✓') ? 'success.main' : 'error.main'}>
                              {qrMsg}
                            </Typography>
                          )}
                        </Grid>
                      )}

                      {QR_ALLOWED.includes(phoneNumber) && singleOrder?.status === 1 && (singleOrder?.paymentMethod === 1 || singleOrder?.paymentMethod === 6) && (
                        <Grid mt={2} p={2} sx={{ border: '1px dashed #9c27b0', borderRadius: 2, background: '#faf0fb' }}>
                          <Typography variant="subtitle1" fontWeight={600} mb={1}>
                            Map Payment From an Old Cancelled/RTO Order
                          </Typography>
                          <Typography variant="body2" color="text.secondary" mb={1}>
                            Use this when a buyer's earlier order was cancelled (or came back RTO) after they'd already paid an advance, and that advance should carry over to this order instead of being refunded. Old order must be Cancelled or RTO and not already mapped elsewhere.
                          </Typography>

                          <TextField
                            size="small"
                            label="Old Order's Numeric Order Id"
                            type="number"
                            value={oldNumericOrderId}
                            onChange={e => { setOldNumericOrderId(e.target.value); setMovePreview(null); setMovePaymentMsg(''); }}
                            sx={{ mr: 1, mb: 1, minWidth: 220 }}
                          />
                          <LoadingButton
                            loading={movePreviewLoading}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            onClick={previewMoveFromOldOrder}
                            sx={{ mb: 1 }}
                          >
                            Fetch
                          </LoadingButton>

                          {movePreview && (
                            <Grid mt={1} p={1.5} sx={{ background: '#fff', borderRadius: 1, border: '1px solid #ce93d8' }}>
                              <Typography variant="body2">
                                {movePreview.oldOrder.status === 4 ? 'RTO' : 'Cancelled'} Order #{movePreview.oldOrder.numericOrderId}: <b>{movePreview.oldOrder.name}</b> ({movePreview.oldOrder.phoneNumber})
                              </Typography>
                              <Typography variant="body2">
                                Payment Id: <b>{movePreview.oldOrder.paymentId}</b> &nbsp;|&nbsp; {movePreview.oldOrder.status === 4 ? 'RTO Amount' : 'Paid Amount'}: <b>₹{movePreview.oldOrder.paidAmount}</b>
                              </Typography>

                              <Grid mt={1} p={1} sx={{ background: '#f5f5f5', borderRadius: 1 }}>
                                <Typography variant="body2" fontWeight={600}>After moving this payment, this order ({movePreview.newOrder.numericOrderId}) will be:</Typography>
                                <Typography variant="body2">Order Total (Total Payable): <b>₹{movePreview.newOrder.totalPayableAmount}</b></Typography>
                                <Typography variant="body2">Current Amount (before this move): <b>₹{movePreview.newOrder.currentPrepaidCollectedAmount}</b></Typography>
                                <Typography variant="body2">{movePreview.oldOrder.status === 4 ? 'RTO' : 'Old Order'} Amount Being Added: <b>₹{movePreview.oldOrder.paidAmount}</b></Typography>
                                <Typography variant="body2">New Prepaid Collected Amount: <b>₹{movePreview.afterMove.prepaidCollectedAmount}</b></Typography>
                                <Typography variant="body2">
                                  New Remaining Amount for COD: <b>₹{movePreview.afterMove.remainingAmountForCod}</b>
                                </Typography>
                                <Typography variant="body2" color={movePreview.afterMove.paymentMethod === 2 ? 'success.main' : 'warning.main'}>
                                  {movePreview.afterMove.paymentMethod === 2 ? '✓ Will become Full Prepaid (Method 2)' : 'Will remain Partial Payment (Method 6)'}
                                </Typography>
                              </Grid>

                              <LoadingButton
                                loading={movePaymentLoading}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={confirmMoveFromOldOrder}
                                sx={{ mt: 1 }}
                              >
                                Confirm & Move Payment
                              </LoadingButton>
                            </Grid>
                          )}

                          {movePaymentMsg && (
                            <Typography variant="body2" mt={1} color={movePaymentMsg.startsWith('✓') ? 'success.main' : 'error.main'}>
                              {movePaymentMsg}
                            </Typography>
                          )}
                        </Grid>
                      )}

                      {singleOrder?.qrPaymentLinked && singleOrder?.status === 1 && (
                        <Typography variant="body2" mt={1} color="success.main">
                          ✓ QR payment{(singleOrder.qrPayments?.length || 0) > 1 ? 's' : ''} linked (₹{singleOrder.qrMappedAmount || singleOrder.prepaidCollectedAmount || singleOrder.razorPayOrderAmount}
                          {(singleOrder.qrPayments?.length || 0) > 1 && ` across ${singleOrder.qrPayments.length} payments`})
                          {singleOrder.remainingAmountForCod > 0 ? ` — ₹${singleOrder.remainingAmountForCod} COD remaining` : ' — ready to capture'}
                        </Typography>
                      )}
                    </Grid>
                    {/* <Grid container item alignItems={"center"}>
                      <Grid item xs={6} mt={1}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                          >
                            <DateTimePicker
                              label="Appointment Date & Time"
                              value={appointmentDate}
                              onChange={(newValue) =>
                                setAppointmentDate(newValue)
                              }
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </Stack>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={bookAppointment}
                          sx={{ marginLeft: 2 }}
                          variant="contained"
                        >
                          Book Appointment
                        </Button>
                      </Grid>
                    </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            </SubCard>
          </Grid>
          {/* Orders placed after 2026-09-10 keep Prime gift picks in their own
              array (see models/BulkOrder.js primeFreeGiftProducts) instead of
              embedding them in products[] — older orders still show their gift
              rows via the "PRIME FREE GIFT" chip inside "All Products" below. */}
          {singleOrder?.primeFreeGiftProducts?.length > 0 && (
            <Grid item xs={12}>
              <SubCard title="FBL Prime Free Gifts" content={false}>
                <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.tableResponsive}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Product Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>MRP</TableCell>
                          <TableCell>Gift MRP Used</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {singleOrder?.primeFreeGiftProducts?.map((row, index) => (
                          <TableRow key={row?.productId || index} style={{ background: "#fff8e1" }}>
                            <TableCell>
                              <Typography variant="subtitle1">{row?.name}</Typography>
                              <Chip
                                size="small"
                                label="PRIME FREE GIFT"
                                style={{ marginTop: 4, background: "#f9a825", color: "#fff", fontWeight: 600 }}
                              />
                            </TableCell>
                            <TableCell>{row?.quantity}</TableCell>
                            <TableCell>{Math.round(row?.mrp || 0)}</TableCell>
                            <TableCell>₹{Math.round((row?.mrp || 0) * (row?.quantity || 0))}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </SubCard>
            </Grid>
          )}
          {singleOrder?.rewardProducts?.length > 0 && (
            <Grid item xs={12}>
              <SubCard title="Reward Products" content={false}>
                <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.tableResponsive}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Product Name</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {singleOrder?.rewardProducts?.map((row, index) => {
                          return (
                            <TableRow key={row?.rewardProductId}>
                              <TableCell>
                                {" "}
                                <Typography variant="subtitle1">
                                  {row?.rewardProductName}{" "}
                                </Typography>
                              </TableCell>
                              <TableCell> {row?.quantity} </TableCell>
                              <TableCell>{Math.round(row?.mrp)}</TableCell>
                              <TableCell>
                                {" "}
                                {Math.round(row?.mrp * row?.quantity)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </SubCard>
            </Grid>
          )}
          <Grid item xs={12}>
            <SubCard title="All Products" content={false}>
              <Grid container spacing={3}>
                <Grid item xs={12} className={classes.tableResponsive}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Product Name</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell>Gift MRP Used</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {singleOrder?.products?.map((row, index) => {
                        const isPrimeGift = !!row?.fblPrimeFreeGift;
                        // Regular (non-Prime) free gift rows carry no boolean flag in
                        // the schema — price 0 on a non-Prime-gift row is the signal.
                        const isRegularFreeGift = !isPrimeGift && Number(row?.price || 0) === 0;
                        const giftMrpUsed = (isPrimeGift || isRegularFreeGift)
                          ? Math.round((row?.mrp || 0) * (row?.quantity || 0))
                          : null;
                        return (
                          <TableRow
                            key={row?._id}
                            style={
                              isPrimeGift
                                ? { background: "#fff8e1" }
                                : isRegularFreeGift
                                ? { background: "#e8f5e9" }
                                : undefined
                            }
                          >
                            <TableCell>
                              {" "}
                              <Typography variant="subtitle1">
                                {row?.name}{" "}
                              </Typography>
                              {isPrimeGift && (
                                <Chip
                                  size="small"
                                  label="PRIME FREE GIFT"
                                  style={{
                                    marginTop: 4,
                                    background: "#f9a825",
                                    color: "#fff",
                                    fontWeight: 600,
                                  }}
                                />
                              )}
                              {isRegularFreeGift && (
                                <Chip
                                  size="small"
                                  label="FREE GIFT"
                                  style={{
                                    marginTop: 4,
                                    background: "#43a047",
                                    color: "#fff",
                                    fontWeight: 600,
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell> {row?.quantity} </TableCell>
                            <TableCell>{Math.round(row?.mrp)}</TableCell>
                            <TableCell>
                              {" "}
                              {Math.round(row?.mrp * row?.quantity)}
                            </TableCell>
                            <TableCell>
                              {giftMrpUsed != null ? `₹${giftMrpUsed}` : "-"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Grid>
                <Grid item xs={12}>
                  <SubCard
                    sx={{ mx: 3, mb: 3 }}
                    contentClass={classes.totalBillAmount}
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      spacing={gridSpacing}
                    >
                      <Grid item sm={6} md={6}>
                        <Grid container item>
                          {role == 1 || role == 4 ? (
                            singleOrder?.couponCode == null ? null : (
                              <Typography variant="h2">
                                Coupon already applied
                              </Typography>
                            )
                          ) : null}
                        </Grid>
                      </Grid>
                      <Grid item sm={12} lg={4} md={4}>
                        <Grid
                          item
                          container
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Typography align="left" variant="subtitle1">
                            {" "}
                            Total Mrp :{" "}
                          </Typography>
                          <Typography align="right" variant="body2">
                            &#8377;{" "}
                            {singleOrder.products &&
                              singleOrder.products.length > 0 &&
                              singleOrder.products.reduce(
                                (acc, cur) => acc + cur.mrp * cur.quantity,
                                0
                              )}
                          </Typography>
                        </Grid>
                        {singleOrder?.codCharge ? (
                          <Grid
                            item
                            container
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Typography align="left" variant="subtitle1">
                              Cod Charge :{" "}
                            </Typography>
                            <Typography align="right" variant="body2">
                              &#8377; {singleOrder.codCharge}
                            </Typography>
                          </Grid>
                        ) : null}
                        <Grid
                          item
                          container
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Typography align="right" variant="subtitle1">
                            {" "}
                            Total Quantity :{" "}
                          </Typography>
                          <Typography align="right" variant="body2">
                            {singleOrder.products &&
                              singleOrder.products.reduce(
                                (acc, cur) => acc + cur.quantity,
                                0
                              )}
                          </Typography>
                        </Grid>
                        {singleOrder?.shippingCost ? (
                          <Grid
                            item
                            container
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Typography align="right" variant="subtitle1">
                              Shipping Charge :{" "}
                            </Typography>
                            <Typography align="right" variant="body2">
                              &#8377; {singleOrder.shippingCost}
                            </Typography>
                          </Grid>
                        ) : null}
                        <Grid>
                          {singleOrder?.discountBreakupInfo1
                            ? singleOrder?.discountBreakupInfo1.map(
                              (disObj, i) => {
                                return (
                                  <Grid
                                    item
                                    container
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                  >
                                    <Typography>
                                      {Object.keys(disObj)}
                                    </Typography>
                                    <Typography variant="h5">
                                      {" "}
                                      - ₹{Math.round(
                                        Object.values(disObj)
                                      )}{" "}
                                    </Typography>
                                  </Grid>
                                );
                              }
                            )
                            : null}
                        </Grid>
                        {singleOrder?.prepaidCollectedAmount ? (
                          <Grid
                            item
                            container
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Typography align="right" variant="subtitle1">
                              Partial Paid :{" "}
                            </Typography>
                            <Typography align="right" variant="body2">
                              &#8377; {singleOrder.prepaidCollectedAmount}
                            </Typography>
                          </Grid>
                        ) : null}

                        {singleOrder?.primeMembershipCharge?.amount ? (
                          <>
                            <Grid
                              item
                              container
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Typography align="right" variant="subtitle1">
                                Order Value (excl. Prime) :{" "}
                              </Typography>
                              <Typography align="right" variant="body2">
                                &#8377;{" "}
                                {Math.round(
                                  (singleOrder.totalPayableAmount || 0) -
                                    singleOrder.primeMembershipCharge.amount
                                )}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              container
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Typography align="right" variant="subtitle1">
                                {singleOrder.primeMembershipCharge.tier
                                  ? `FBL Prime ${singleOrder.primeMembershipCharge.tier.charAt(0).toUpperCase()}${singleOrder.primeMembershipCharge.tier.slice(1)}`
                                  : "FBL Prime"}{" "}Membership (COD) :{" "}
                                <Chip
                                  size="small"
                                  label={(
                                    singleOrder.primeMembershipCharge.status || "pending"
                                  ).toUpperCase()}
                                  style={{
                                    marginLeft: 4,
                                    fontWeight: 600,
                                    color: "#fff",
                                    background:
                                      singleOrder.primeMembershipCharge.status === "granted"
                                        ? "#43a047"
                                        : singleOrder.primeMembershipCharge.status === "voided"
                                        ? "#9e9e9e"
                                        : "#f9a825",
                                  }}
                                />
                              </Typography>
                              <Typography align="right" variant="body2">
                                + &#8377; {singleOrder.primeMembershipCharge.amount}
                              </Typography>
                            </Grid>
                            {singleOrder.primeMembershipCharge.status === "pending" && (
                              <Grid item container justifyContent={"flex-end"}>
                                <Typography
                                  align="right"
                                  variant="caption"
                                  style={{ color: "#9e5b00" }}
                                >
                                  Membership grants only once this order is delivered.
                                </Typography>
                              </Grid>
                            )}
                            {singleOrder.primeMembershipCharge.status === "voided" && (
                              <Grid item container justifyContent={"flex-end"}>
                                <Typography
                                  align="right"
                                  variant="caption"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Voided{singleOrder.primeMembershipCharge.voidReason
                                    ? `: ${singleOrder.primeMembershipCharge.voidReason}`
                                    : ""}
                                </Typography>
                              </Grid>
                            )}
                          </>
                        ) : null}

                        <Grid
                          item
                          container
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Typography
                            align="right"
                            color="primary"
                            variant="subtitle1"
                          >
                            {" "}
                            Total :{" "}
                          </Typography>
                          <Typography
                            align="right"
                            color="primary"
                            variant="subtitle1"
                          >
                            {" "}
                            &#8377; {singleOrder.totalPayableAmount}{" "}
                          </Typography>
                        </Grid>
                        {singleOrder?.prepaidCollectedAmount ? (
                          <Grid
                            item
                            container
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Typography align="right" variant="subtitle1">
                              Remaining Amount :{" "}
                            </Typography>
                            <Typography align="right" variant="body2">
                              &#8377; {singleOrder.remainingAmountForCod}
                            </Typography>
                          </Grid>
                        ) : null}
                      </Grid>
                    </Grid>
                  </SubCard>
                </Grid>
              </Grid>
            </SubCard>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <BulkInvoice singleOrder={singleOrder} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PerformaInvoice singleOrder={singleOrder} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        {singleOrder && ["9315481432", "9719836187","9891774071", "9811068834"].includes(phoneNumber) && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, alignItems: 'center' }}>
            <TextField
              label="AWB Number"
              variant="outlined"
              size="small"
              value={newAwbNumber}
              onChange={(e) => setNewAwbNumber(e.target.value)}
              style={{ marginRight: '10px' }}
            />
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={handleUpdateAwb}
              loading={loadingUpdateAwb}
            >
              Update
            </LoadingButton>
          </Box>
        )}
        <OrderStatus
          singleOrder={singleOrder}
          orderAwbNumber={singleOrder?.awbNumber}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Grid container spacing={gridSpacing}>
          <Grid item xs={12}>
            <OrderStatusBar order={singleOrder} />
          </Grid>
          {singleOrder?.shiprocketLogs && (
            <Grid item xs={12}>
              <OrderHistory order={singleOrder} />
            </Grid>
          )}
          {singleOrder?.cancelledBy?.cancelLater === true && singleOrder?.status === 1 && (
            <Grid item xs={12}>
              <Card variant="outlined" style={{ borderColor: "#ed6c02", backgroundColor: "#fff7ed" }}>
                <CardContent>
                  <Typography variant="subtitle1" style={{ color: "#ed6c02", fontWeight: 600 }}>
                    Cancellation Requested — pending review
                  </Typography>
                  <Typography variant="body2">Reason: {singleOrder?.cancelledBy?.reasonText || "NA"}</Typography>
                  <Typography variant="body2">Remarks: {singleOrder?.cancelledBy?.remarks || "NA"}</Typography>
                  <Typography variant="body2">
                    Requested On: {singleOrder?.cancelledBy?.cancelledAt ? moment(singleOrder.cancelledBy.cancelledAt).format("DD-MMM-YYYY hh:mm A") : "NA"}
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: 8 }}>
                    Order is on hold and cannot move forward until this is resolved from the Cancellation Requests tab.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          )}
          {FORCE_CANCEL_ALLOWED.includes(phoneNumber) && singleOrder?.status === 1 && (
            <Grid item xs={12}>
              <Button
                variant="contained"
                style={{ backgroundColor: "red", color: "white" }}
                onClick={() => {
                  setCancelDialogMode("force");
                  setShowCancelModal(true);
                }}
              >
                Cancel Order
              </Button>
            </Grid>
          )}
          {!FORCE_CANCEL_ALLOWED.includes(phoneNumber) &&
            singleOrder?.status === 1 &&
            singleOrder?.cancelledBy?.cancelLater !== true && (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#ed6c02", color: "white" }}
                  onClick={() => {
                    setCancelDialogMode("request");
                    setShowCancelModal(true);
                  }}
                >
                  Request Cancellation
                </Button>
              </Grid>
            )}
          {REOPEN_ALLOWED.includes(phoneNumber) && singleOrder?.status === 2 && !singleOrder?.awbNumber && (
            <Grid item xs={12}>
              <LoadingButton
                variant="contained"
                color="success"
                loading={reopenLoading}
                onClick={handleReopenOrder}
              >
                Reopen Order (Move to Processing)
              </LoadingButton>
            </Grid>
          )}
        </Grid>
        <Dialog open={showCancelModal} onClose={() => setShowCancelModal(false)} maxWidth="sm" fullWidth>
          <DialogTitle>{cancelDialogMode === "force" ? "Cancel Order" : "Request Cancellation"}</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: 12 }}>
              {cancelDialogMode === "force"
                ? "Please provide the cancellation details below."
                : "This will not cancel the order immediately — it will be held and sent for review. The order can't move forward until it's approved or rejected."}
            </DialogContentText>
            <CancelOrderReasonFields
              reason={cancelReason}
              remark={cancelRemarks}
              onReasonChange={setCancelReason}
              onRemarkChange={setCancelRemarks}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowCancelModal(false)} disabled={cancelLoading || requestCancelLoading}>
              Close
            </Button>
            <LoadingButton
              loading={cancelDialogMode === "force" ? cancelLoading : requestCancelLoading}
              variant="contained"
              disabled={!cancelReason.trim()}
              style={{ backgroundColor: "red", color: "white" }}
              onClick={cancelDialogMode === "force" ? handleForceCancel : handleRequestCancel}
            >
              {cancelDialogMode === "force" ? "Confirm Cancel" : "Submit Request"}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <SubCard title="Zoho Invoice Details">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">
                Invoice ID: &nbsp;
                <Typography component="span" variant="body2">
                  {singleOrder?.zohoInvoice?.id}
                </Typography>
              </Typography>
              <Typography variant="subtitle1">
                Invoice Number: &nbsp;
                <Typography component="span" variant="body2">
                  {singleOrder?.zohoInvoice?.zohoInvoiceNumber}
                </Typography>
              </Typography>
              <Typography variant="subtitle1">
                Total: &nbsp;
                <Typography component="span" variant="body2">
                  &#8377; {singleOrder?.zohoInvoice?.total}
                </Typography>
              </Typography>
              <Typography variant="subtitle1">
                Created At: &nbsp;
                <Typography component="span" variant="body2">
                  {singleOrder?.zohoInvoice?.createdAt && new Date(singleOrder?.zohoInvoice?.createdAt).toLocaleString()}
                </Typography>
              </Typography>
            </Grid>
           
            <Grid item xs={12} container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="PO Number"
                  value={poNumber}
                  onChange={(e) => setPoNumber(e.target.value)}
                  disabled={!["9719836187", "7838688729"].includes(phoneNumber)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Box Count"
                  value={boxCount}
                  onChange={(e) => setBoxCount(e.target.value)}
                  disabled={!["9719836187", "7838688729"].includes(phoneNumber)}
                />
              </Grid>
              {["9719836187", "7838688729"].includes(phoneNumber) && (
                <Grid item xs={12} sm={4}>
                  <LoadingButton
                    variant="contained"
                    onClick={updateZohoInvoiceDetails}
                    loading={loadingOfPlaceOrder}
                  >
                    Update
                  </LoadingButton>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12}>
              <iframe
                src={singleOrder?.zohoInvoice?.invoiceUrl}
                width="100%"
                height="800px"
                title="Zoho Invoice"
                style={{ border: "none" }}
              />
            </Grid>
          </Grid>
        </SubCard>
      </TabPanel>
      <TabPanel value={value} index={6}>
        <MainCard title="Map Payment">
          {(singleOrder?.paymentMethod === 2 || singleOrder?.paymentMethod === 6) ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h4" gutterBottom style={{ color: singleOrder?.paymentMethod === 6 ? '#ed6c02' : '#2e7d32' }}>
                  {singleOrder?.paymentMethod === 6 ? "Partially Paid Order" : "Fully Prepaid Order"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Payment ID: &nbsp;
                  <Typography component="span" variant="body2">
                    {singleOrder?.razorPayOrderId || singleOrder?.razorPayObj?.id || "-"}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Prepaid Collected Amount: &nbsp;
                  <Typography component="span" variant="body2">
                    &#8377; {singleOrder?.prepaidCollectedAmount || (singleOrder?.paymentMethod === 2 ? singleOrder?.totalPayableAmount : 0)}
                  </Typography>
                </Typography>
              </Grid>
              {singleOrder?.paymentMethod === 6 && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    Remaining Amount for COD: &nbsp;
                    <Typography component="span" variant="body2">
                      &#8377; {singleOrder?.remainingAmountForCod || 0}
                    </Typography>
                  </Typography>
                </Grid>
              )}
              {singleOrder?.manualMappedPayments?.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>Mapped Payments:</Typography>
                  {singleOrder.manualMappedPayments.map((p, i) => (
                    <Typography key={p._id || i} variant="body2" style={{ marginBottom: 4 }}>
                      {i + 1}. {p.paymentId} — &#8377; {p.amount}
                      {p.paymentReceivedAt ? ` — ${p.paymentReceivedAt}` : ""}
                      {p.mappedAt ? ` (mapped ${dayjs(p.mappedAt).format("DD MMM YYYY, hh:mm A")})` : ""}
                      {" — "}
                      {p.screenshotUrl ? (
                        <a href={p.screenshotUrl} target="_blank" rel="noopener noreferrer">View Screenshot</a>
                      ) : (
                        "No screenshot"
                      )}
                    </Typography>
                  ))}
                </Grid>
              )}
            </Grid>
          ) : null}
          {(canMapPayment && singleOrder?.paymentMethod !== 2 && remainingPayable > 0) && (
            <Grid container spacing={3} style={{ marginTop: isPartialPaidOrder ? 8 : 0 }}>
              {isPartialPaidOrder && (
                <Grid item xs={12}>
                  <Typography variant="h5">Map Another Payment</Typography>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Amount"
                  type="number"
                  value={mapPaymentData.amount}
                  onChange={(e) => setMapPaymentData({ ...mapPaymentData, amount: e.target.value })}
                  inputProps={{ min: 1, max: remainingPayable }}
                  error={Number(mapPaymentData.amount) > remainingPayable}
                  helperText={`Max ₹${remainingPayable} (Total ₹${singleOrder?.totalPayableAmount || 0}${isPartialPaidOrder ? `, already collected ₹${alreadyCollected}` : ""})`}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Payment ID"
                  value={mapPaymentData.paymentId}
                  onChange={(e) => setMapPaymentData({ ...mapPaymentData, paymentId: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label="Payment Date & Time (Optional)"
                    value={mapPaymentData.paymentDateAndTime}
                    onChange={(newValue) => setMapPaymentData({ ...mapPaymentData, paymentDateAndTime: newValue })}
                    renderInput={(params) => <TextField {...params} fullWidth helperText="Format: YYYY-MM-DD HH:mm:ss" />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button variant="outlined" component="label" fullWidth>
                  {mapPaymentData.screenshot ? `Screenshot: ${mapPaymentData.screenshot.name}` : "Upload Payment Screenshot *"}
                  <input
                    key={screenshotInputKey}
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={(e) => setMapPaymentData({ ...mapPaymentData, screenshot: e.target.files?.[0] || null })}
                  />
                </Button>
                <Typography variant="caption" color="textSecondary">Required for every payment (image, max 10MB)</Typography>
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={handleMapPaymentSubmit}>
                  Submit Payment
                </Button>
              </Grid>
            </Grid>
          )}
        </MainCard>

        {/* Popup for Response */}
        <Dialog
          open={openPaymentPopup}
          onClose={() => setOpenPaymentPopup(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ color: paymentResponse?.success === false ? 'red' : 'inherit' }}>
            {paymentResponse?.success === false ? 'Error' : 'Payment Response'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <pre style={{
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
                color: paymentResponse?.success === false ? 'red' : 'inherit',
                fontWeight: paymentResponse?.success === false ? 'bold' : 'normal'
              }}>
                {JSON.stringify(paymentResponse, null, 2)}
              </pre>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </TabPanel>
      <TabPanel value={value} index={7}>
        <MainCard title="Replacement Details">
          {singleOrder?.isReplacementOrder ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h4" color="primary">
                  This is a Replacement Order
                </Typography>
                <Typography variant="subtitle1" mt={2}>
                  Replacement Reason: &nbsp;
                  <Typography component="span" variant="body2">
                    {singleOrder?.replacementReason || "N/A"}
                  </Typography>
                </Typography>
                <Box mt={2}>
                   <Button 
                     variant="contained" 
                     component={Link} 
                     to={`/bulk/bulkorderdetails/${singleOrder?.parentId}`} 
                     target="_blank"
                   >
                     Details
                   </Button>
                </Box>
              </Grid>
            </Grid>
          ) : (
            (singleOrder?.status === 1 && !singleOrder?.awbNumber) ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h4">Make this a Replacement Order</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="Replacement From"
                    value={replacementType}
                    onChange={(e) => setReplacementType(e.target.value)}
                    SelectProps={{ native: true }}
                    variant="outlined"
                  >
                    <option value=""></option>
                    <option value="online">From online order</option>
                    <option value="invoice">From invoice id</option>
                  </TextField>
                </Grid>
                
                {replacementType === "online" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Delivered Order ID"
                      value={replacementDeliveredOrderId}
                      onChange={(e) => setReplacementDeliveredOrderId(e.target.value)}
                      required
                    />
                  </Grid>
                )}

                {replacementType === "invoice" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Invoice Number"
                      value={replacementInvoiceNumber}
                      onChange={(e) => setReplacementInvoiceNumber(e.target.value)}
                      required
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={replacementType ? 12 : 6}>
                  <TextField
                    fullWidth
                    label="Replacement Reason"
                    value={replacementReason}
                    onChange={(e) => setReplacementReason(e.target.value)}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <LoadingButton 
                    variant="contained" 
                    color="primary" 
                    onClick={makeReplacementOrder}
                    loading={replacementLoading}
                  >
                    Make Replacement Order
                  </LoadingButton>
                </Grid>
              </Grid>
            ) : null
          )}
        </MainCard>
      </TabPanel>
      <RefundModal
        open={openRefundModal}
        onClose={() => {
          setOpenRefundModal(false);
        }}
        orderId={singleOrder?._id}
        refundAmount={
          singleOrder?.paymentMethod == 6
            ? singleOrder?.prepaidCollectedAmount
            : singleOrder?.totalPayableAmount
        }
      />
      <OtpModal
        open={otpModalOpen}
        handleClose={() => setOtpModalOpen(false)}
        handleVerify={handleOtpVerify}
        phoneNumber={phoneNumber}
      />
      <EditAddressInOrderModal
        open={!!openEditAddress}
        handleClose={() => setOpenEditAddress(null)}
        addressType={openEditAddress}
        oldAddress={openEditAddress === "billing" ? singleOrder?.billingAddress : singleOrder?.address}
        selectedOrderId={singleOrder?._id}
        dataLoad={() => dataLoad(false)}
      />
    </MainCard>
  );
};

export default BulkOrderDetails;
